<mat-toolbar class="mat-primary">
  <span fxFlex>Gültige Ausweise für Sparte {{ data.areaType.description }}</span>
  <mat-icon class="cursor-mat-element" (click)="onCancel()">close</mat-icon>
</mat-toolbar>
<mat-dialog-content>
  <ag-grid-angular
    [localeText]="localeText"
    class="ag-theme-material"
    [rowData]="data.validPasses"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    style="width: 100%; height: 300px"
    (cellClicked)="onSelectPass($event.data)"></ag-grid-angular>
  <p>Wählen Sie einen Ausweis mit dem Sie die Inbetriebnahme anlegen möchten.</p>
  <div class="button-container">
    <button mat-stroked-button color="primary" (click)="onCancel()">Abbrechen</button>
  </div>
</mat-dialog-content>
